var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E7EDFC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7847_26568",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 25,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6666,
    y: 12,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7847_26568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1666 30.8V28.5C31.1666 28.3667 31.1166 28.25 31.0166 28.15C30.9166 28.05 30.8 28 30.6666 28C30.5333 28 30.4166 28.05 30.3166 28.15C30.2166 28.25 30.1666 28.3667 30.1666 28.5V30.775C30.1666 30.9083 30.1916 31.0375 30.2416 31.1625C30.2916 31.2875 30.3666 31.4 30.4666 31.5L31.9666 33C32.0666 33.1 32.1833 33.15 32.3166 33.15C32.45 33.15 32.5666 33.1 32.6666 33C32.7666 32.9 32.8166 32.7833 32.8166 32.65C32.8166 32.5167 32.7666 32.4 32.6666 32.3L31.1666 30.8ZM24.6666 24.85C24.85 24.85 25.025 24.825 25.1916 24.775C25.3583 24.725 25.5166 24.6583 25.6666 24.575L30.7416 21.65C30.975 21.5167 31.125 21.3125 31.1916 21.0375C31.2583 20.7625 31.225 20.5083 31.0916 20.275C30.9583 20.0417 30.7583 19.8917 30.4916 19.825C30.225 19.7583 29.975 19.7917 29.7416 19.925L24.6666 22.85L19.5916 19.925C19.3583 19.7917 19.1083 19.7583 18.8416 19.825C18.575 19.8917 18.375 20.0417 18.2416 20.275C18.1083 20.5083 18.0791 20.7625 18.1541 21.0375C18.2291 21.3125 18.3833 21.5167 18.6166 21.65L23.6666 24.575C23.8166 24.6583 23.975 24.725 24.1416 24.775C24.3083 24.825 24.4833 24.85 24.6666 24.85ZM15.6666 27.975V20.025C15.6666 19.6583 15.7541 19.325 15.9291 19.025C16.1041 18.725 16.35 18.4833 16.6666 18.3L23.6666 14.275C23.8333 14.1917 23.9958 14.125 24.1541 14.075C24.3125 14.025 24.4833 14 24.6666 14C24.85 14 25.025 14.025 25.1916 14.075C25.3583 14.125 25.5166 14.1917 25.6666 14.275L32.6666 18.3C32.9833 18.4833 33.2291 18.725 33.4041 19.025C33.5791 19.325 33.6666 19.6583 33.6666 20.025V23.425C33.6666 23.725 33.5416 23.9583 33.2916 24.125C33.0416 24.2917 32.775 24.3333 32.4916 24.25C32.2083 24.1667 31.9125 24.1042 31.6041 24.0625C31.2958 24.0208 30.9833 24 30.6666 24C28.7333 24 27.0833 24.6833 25.7166 26.05C24.35 27.4167 23.6666 29.0667 23.6666 31V31.5125C23.6666 31.6708 23.6833 31.8167 23.7166 31.95C23.7833 32.3667 23.6625 32.6917 23.3541 32.925C23.0458 33.1583 22.725 33.1833 22.3916 33L16.6666 29.7C16.35 29.5167 16.1041 29.275 15.9291 28.975C15.7541 28.675 15.6666 28.3417 15.6666 27.975ZM30.6666 36C29.2833 36 28.1041 35.5125 27.1291 34.5375C26.1541 33.5625 25.6666 32.3833 25.6666 31C25.6666 29.6167 26.1541 28.4375 27.1291 27.4625C28.1041 26.4875 29.2833 26 30.6666 26C32.05 26 33.2291 26.4875 34.2041 27.4625C35.1791 28.4375 35.6666 29.6167 35.6666 31C35.6666 32.3833 35.1791 33.5625 34.2041 34.5375C33.2291 35.5125 32.05 36 30.6666 36Z",
    fill: "#41558D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.6ae1e92616e989f50d4479c286654506.svg";
export { ForwardRef as ReactComponent };